module.exports = __webpack_public_path__ + "img/shopify.33ea533.svg";